import { render, staticRenderFns } from "./consultant-apply.vue?vue&type=template&id=3964ac44&scoped=true&"
import script from "./consultant-apply.vue?vue&type=script&lang=js&"
export * from "./consultant-apply.vue?vue&type=script&lang=js&"
import style0 from "./consultant-apply.vue?vue&type=style&index=0&id=3964ac44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3964ac44",
  null
  
)

export default component.exports